/* global window */
'use strict';

// Based on the old phxCategorizr behavior; determine (broadly) browser type
// and version, for browser-specific CSS hacks.

module.exports = {
    get: function () {
        let agent = (window && window.navigator && window.navigator.userAgent) || false,
            result = {
                found: false,
                type: undefined,
                version: undefined,
                // iOS version is used for a single workaround, in the card
                // CSS; we want to distinguish between mobile and desktop
                // Safari.
                iOS: undefined,
                samsung: undefined,
            },
            searchVersion = function (dataString, str) {
                var index = dataString.indexOf(str);
                if (index === -1) {
                    return;
                }
                var ver = parseInt(dataString.substring(index + str.length + 1)) || null;
                return ver;
            },
            ruleSet = [
                {
                    cond: /MSIE/gi,
                    versearch: 'MSIE',
                    result: 'MSIE',
                },
                {
                    cond: /Trident/gi,
                    versearch: '; rv',
                    result: 'MSIE',
                },
                {
                    cond: /\sEdge\/\d+\.\d+/gi,
                    versearch: ' Edge',
                    result: 'Edge',
                },
                {
                    cond: /Chrome/gi,
                    versearch: 'Chrome',
                    result: 'Chrome',
                },
                {
                    cond: /Opera/gi,
                    versearch: 'Version',
                    result: 'Opera',
                },
                {
                    cond: /Safari/gi,
                    versearch: 'Version',
                    result: 'Safari',
                },
                {
                    cond: /Firefox/gi,
                    versearch: 'Firefox',
                    result: 'Firefox',
                },
            ];
        if (agent) {
            for (var b = 0; b < ruleSet.length; b++) {
                if (agent.match(ruleSet[b].cond)) {
                    result.found = true;
                    result.type = ruleSet[b].result;
                    result.version = searchVersion(agent, ruleSet[b].versearch);
                    break;
                }
            }
            if (agent.match(/iP(a|ro)d/gi) || agent.match(/iPhone/gi)) {
                result.iOS = searchVersion(agent, 'OS');
            }

            if (agent.match(/Samsung/gi)) {
                result.samsung = true;
            }
        }
        return result;
    },
};
